import React from "react";

// assets
import websitemaintenance from "../../../assets/images/img/underConstruct.svg"

const UnderConstruction = () => {
  return (
    <div className="salemain">
      <img src={websitemaintenance} alt="websitemaintenance" className="img-fluid  mx-auto d-block" />
    </div>
  );
}

export default UnderConstruction;